// assets
import {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconWallet,
    IconArrowBigUpLines,
    IconDeviceMobile,
    IconHandFinger,
    IconFileInvoice,
    IconChartInfographic,
    IconArrowsTransferDown,
    IconCalculator,
    IconHeartHandshake,
    IconCreditCard,
    IconFingerprint,
    IconCash,
    IconQrcode,
    IconClearAll
} from '@tabler/icons';

// constant
const icons = {
    IconTypography,

    IconPalette,
    IconShadow,
    IconWindmill,
    IconWallet,
    IconArrowBigUpLines,
    IconDeviceMobile,
    IconHandFinger,
    IconFileInvoice,
    IconChartInfographic,
    IconArrowsTransferDown,
    IconCalculator,
    IconHeartHandshake,
    IconCreditCard,
    IconFingerprint,
    IconCash,
    IconQrcode,
    IconClearAll
};
const bbpsReport = localStorage.getItem('bbpsNewReport');
const rmemployee = localStorage.getItem('rmemployee') === 'true';
const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    title: '',

    children: [
        {
            id: 'icons2',
            title: 'Reports',
            type: 'collapse',
            icon: icons.IconChartInfographic,
            children: [
                {
                    id: 'all-transactions',
                    title: 'All Transactions',
                    type: 'item',
                    url: '/merchants/all-transactions',
                    icon: icons.IconClearAll,
                    breadcrumbs: false
                },
                {
                    id: 'sample-page',
                    title: 'DMT',
                    type: 'item',
                    url: '/dmt/dmtreport',
                    icon: icons.IconArrowsTransferDown,
                    breadcrumbs: false
                },
                {
                    id: 'aaadhar',
                    title: 'Aadhaar Pay',
                    type: 'item',
                    url: '/aeps/aadhaarpayreport',
                    icon: icons.IconFingerprint
                },
                !rmemployee && {
                    id: 'documentationAeps',
                    title: 'AEPS',
                    type: 'item',
                    url: '/aeps/AepsReport',
                    icon: icons.IconHandFinger
                    // external: true,
                    // target: true
                },
                !rmemployee && {
                    id: 'documentationAeps1',
                    title: 'Cash Deposit',
                    type: 'item',
                    url: '/cashdeposit/cash-deposit-report',
                    icon: icons.IconCash
                    // external: true,
                    // target: true
                },
                {
                    id: 'documentationRecharges',
                    title: 'Recharges',
                    type: 'item',
                    url: '/BBPS/rechargereport',
                    icon: icons.IconDeviceMobile
                    // external: true,
                    // target: true
                },
                {
                    id: 'documentationBillpayments',
                    title: 'Bill Payments',
                    type: 'item',
                    url: '/BBPS/bbpsreport',
                    icon: icons.IconFileInvoice
                    // external: true,
                    // target: true
                },
                !rmemployee && {
                    id: 'documentationPos',
                    title: 'POS',
                    type: 'item',
                    url: '/pos/pos-report',
                    icon: icons.IconCalculator
                    // external: true,
                    // target: true
                },
                {
                    id: 'documentationqr',
                    title: 'QR',
                    type: 'item',
                    url: '/qr/qr-report',
                    icon: icons.IconQrcode
                },
                !rmemployee && {
                    id: 'documentationMatm',
                    title: 'MATM',
                    type: 'item',
                    url: '/matm/matm-report',
                    icon: icons.IconDeviceMobile
                    // external: true,
                    // target: true
                },
                {
                    id: 'documentationUpiAtm',
                    title: 'UPI ATM',
                    type: 'item',
                    url: '/atmupi-history',
                    icon: icons.IconCreditCard
                },
                {
                    id: 'documentationInsurance',
                    title: 'Insurance',
                    type: 'item',
                    url: '/common-service/insurance-report',
                    icon: icons.IconCreditCard
                },
                bbpsReport === 'true'
                    ? {
                          id: 'documentationBBpsBiller',
                          title: 'BBPS Biller',
                          type: 'item',
                          url: '/bbps/bbpsbillerreport',
                          icon: icons.IconFileInvoice
                      }
                    : null
            ].filter(Boolean)
        }
    ]
};

export default other;
